import getConfig from 'next/config';

import React from 'react';
import Raven from 'raven-js';

const {
  publicRuntimeConfig: {
    sentryDsn: SENTRY_DSN,
    commit: COMMIT,
    buildId: BUILD_ID,
  },
} = getConfig();

function withSentry(Child) {
  return class WrappedComponent extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        error: null,
      };
      if (__DEV__) return;
      Raven.config(SENTRY_DSN, {
        release: COMMIT,
        tags: { BUILD_ID, COMMIT },
        environment: typeof window !== 'undefined' ? window.location.host : '',
        debug: !!__DEV__,
      }).install();
    }

    static getInitialProps(context) {
      if (Child.getInitialProps) {
        return Child.getInitialProps(context);
      }
      return {};
    }

    componentDidCatch(error, errorInfo) {
      this.setState({ error });
      if (__DEV__) return;
      Raven.captureException(error, { extra: errorInfo });
    }

    render() {
      return <Child {...this.props} error={this.state.error} />;
    }
  };
}

export default withSentry;
